import { render, staticRenderFns } from "./form.vue?vue&type=template&id=62e89560&lang=pug&"
import script from "./form.vue?vue&type=script&setup=true&lang=js&"
export * from "./form.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports